<template>
    <q-page class="q-pa-md">
        <q-table
                 :loading="loading"
                 :columns="columns"
                 :visible-columns="columnsVisible"
                 :data="dataSource"
                 :filter="filter"
                 :pagination="pagination"
                 
                 
                 
                 
                 row-key="Id">
            <template v-slot:top>
                <q-toolbar v-if="screenTitle">
                    <div class="q-table__title">
                        {{ screenTitle }}
                    </div>

                    <q-space></q-space>
                </q-toolbar>

                <q-toolbar>
                    <q-input outlined v-model="filter" 
                                      dense clearable clear-icon="close"
                                      placeholder="Search" debounce="300" 
                                      style="width:250px" class="q-mr-xs">
                        <template v-slot:prepend>
                            <q-icon name="search"></q-icon>
                        </template>
                    </q-input>
                    <q-btn round dense flat color="primary" icon="refresh" @click="refreshScreen">
                        <q-tooltip content-class="bg-white text-black shadow-4" content-style="font-size: 12px">
                            REFRESH
                        </q-tooltip>
                    </q-btn>

                    <q-space></q-space>

                    <div class="q-gutter-xs">
                        <q-btn label="Create" 
                      
                      
                     color="primary" 
                     :disable="actionLocked" 
                     @click="onCreateActionClick()">
                  
              </q-btn>

                        
                    </div>
                </q-toolbar>
            </template>          
            
            
            <template v-slot:body-cell-Actions="props">
                <q-td :props="props" auto-width>
                    <div class="q-gutter-xs">
                        <q-btn label="Edit" 
                      
                      
                     color="primary" 
                     :disable="actionLocked" 
                     @click="onEditActionClick(props.key, props.rowIndex, props.row)">
                  
              </q-btn>
                <q-btn label="Delete" 
                      
                      
                     color="primary" 
                     :disable="actionLocked" 
                     @click="onDeleteActionClick(props.key, props.rowIndex, props.row)">
                  
              </q-btn>

                    </div>
                </q-td>
            </template>
            
            
        </q-table>
    </q-page>
</template>

<style>
    
</style>

<script>
    export { default } from './globalconfigurationlistmodel-list-screen.js'
</script>